import {
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { SettingsAnchorService } from '@configuration/shared/settings-search/settings-anchor.service';

/**
 * Marks a setting card as a deep-link target: `<div class="card" appSettingAnchor="is_idle_enabled">`
 * gives the card `id="is_idle_enabled"`, makes it focusable and registers it
 * with `SettingsAnchorService` so `/settings/<tab>#is_idle_enabled` (and the
 * settings search) can scroll to and highlight it.
 */
@Directive({
  selector: '[appSettingAnchor]',
  standalone: false
})
export class SettingAnchorDirective implements OnInit, OnDestroy {
  @Input('appSettingAnchor') public anchorId: string;

  @HostBinding('class.v-anchor') public readonly anchorClass = true;
  @HostBinding('attr.tabindex') public readonly tabindex = -1;

  constructor(
    private readonly _anchors: SettingsAnchorService,
    private readonly _element: ElementRef<HTMLElement>
  ) {}

  @HostBinding('attr.id')
  public get id(): string {
    return this.anchorId;
  }

  ngOnInit(): void {
    this._anchors.register(this.anchorId, this._element.nativeElement);
  }

  ngOnDestroy(): void {
    this._anchors.unregister(this.anchorId, this._element.nativeElement);
  }
}
